var faqItems = document.querySelectorAll('.faq-accordion__item');

if (faqItems.length !== 0) {
    faqItems.forEach(function (item) {
        var btn = item.querySelector('.faq-accordion__question');
        var answer = item.querySelector('.faq-accordion__answer');
        if (! btn || ! answer) {
            return;
        }
        btn.addEventListener('click', function () {
            var isOpen = item.classList.contains('open');

            faqItems.forEach(function (other) {
                other.classList.remove('open');
                var otherBtn = other.querySelector('.faq-accordion__question');
                var otherAnswer = other.querySelector('.faq-accordion__answer');
                if (otherBtn) {
                    otherBtn.setAttribute('aria-expanded', 'false');
                }
                if (otherAnswer) {
                    otherAnswer.style.maxHeight = null;
                }
            });

            if (! isOpen) {
                item.classList.add('open');
                btn.setAttribute('aria-expanded', 'true');
                answer.style.maxHeight = answer.scrollHeight + 'px';
            }
        });
    });
}